/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import { useSlackDestinations } from '../../../utils/integrations';

function dataMapper(data) {
  return data.map((item) => {
    return {
      label: item.type === 'channel' ? `#${item.name}` : item.real_name,
      value: item.id,
    };
  });
}

export default function SlackDestinationPicker({ value, onChange, label }) {
  const { t } = useTranslation();
  const { data: slackDestinations, isLoading: isLoadingSlack } = useSlackDestinations();

  return (
    <Autocomplete
      size="small"
      loading={isLoadingSlack}
      options={dataMapper(slackDestinations || [])}
      value={value ? {
        label: slackDestinations?.find(d => d.id === value)?.type === 'channel' 
          ? `#${slackDestinations?.find(d => d.id === value)?.name}`
          : slackDestinations?.find(d => d.id === value)?.real_name,
        value: value
      } : null}
      onChange={(_, newValue) => {
        onChange(newValue?.value || '');
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          placeholder={label || t('Välj destination')}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoadingSlack ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>
          {option.label}
        </li>
      )}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      noOptionsText={t('Inga alternativ')}
      slotProps={{
        popper: {
          sx: {
            zIndex: 5000
          }
        }
      }}
    />
  );
} 
